import { ArrowsClockwise } from "@phosphor-icons/react";

export default function AdminPrimaryButton({
  busy = false,
  busyLabel = "Saving…",
  children,
  icon,
  className = "",
  ...props
}) {
  return (
    <button
      {...props}
      disabled={busy || props.disabled}
      className={`inline-flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-lg px-5 py-2.5 text-sm transition-colors ${className}`}
    >
      {busy ? (
        <>
          <ArrowsClockwise size={14} className="animate-spin" />
          {busyLabel}
        </>
      ) : (
        <>
          {icon}
          {children}
        </>
      )}
    </button>
  );
}
